<template>
  <div>
    <div class="marginCenter">
      <div class="marginBom30 marginTop30 navTitle flex-yCenter flex-sb">
        <div class="left flex">
          <div class="line"></div>
          <span>提交申请</span>
        </div>
        <div v-if="active == 1 || active == 5" class="right flex-yCenter">
          <img src="@/assets/images/index/fanhui.png" alt="" /><router-link
            tag="span"
            to="/add/index"
            class="backIndex fcolor_blue2 fsize16"
            >返回首页</router-link
          >
        </div>
      </div>
      <div class="step">
        <el-steps :active="progress" align-center>
          <el-step title="选择申请类型"></el-step>
          <el-step title="提交申请表"></el-step>
          <el-step title="上传进修申请表"></el-step>
          <el-step title="提交成功"></el-step>
        </el-steps>
      </div>
      <AddType v-if="active == 1" @getStroge="getStroge" />
      <template v-if="isNurse==0">
        <ApplicationOne v-if="active == 2" />
        <ApplicationTwo v-else-if="active == 3" />
        <ApplicationThree v-else-if="active == 4" />
        <UoloadApplication v-else-if="active == 5" />
      </template>
      <template v-if="isNurse==1">
        <nurseApplicationOne v-if="active == 2" />
        <nurseApplicationTwo v-else-if="active == 3" />
        <nurseApplicationThree v-else-if="active == 4" />
        <nurseUoloadApplication v-else-if="active == 5" />
      </template>
      <template v-if="isNurse==2">
        <administrativeApplicationOne v-if="active == 2" />
        <administrativeApplicationTwo v-else-if="active == 3" />
        <administrativeApplicationThree v-else-if="active == 4" />
        <administrativeUoloadApplication v-else-if="active == 5" />
      </template>
      <SubmitSuccess v-if="active == 6" />
    </div>
  </div>
</template>
<script>
import AddType from "./components/addType.vue";
import ApplicationOne from "./components/applicationOne.vue";
import ApplicationTwo from "./components/applicationTwo.vue";
import ApplicationThree from "./components/applicationThree.vue";
import UoloadApplication from "./components/uploadApplication.vue";
import SubmitSuccess from "./components/submitSuccess.vue";
import nurseApplicationOne from "./nurse/applicationOne.vue";
import nurseApplicationTwo from "./nurse/applicationTwo.vue";
import nurseApplicationThree from "./nurse/applicationThree.vue";
import nurseUoloadApplication from "./nurse/uploadApplication.vue";
import administrativeApplicationOne from "./administrative/applicationOne.vue";
import administrativeApplicationTwo from "./administrative/applicationTwo.vue";
import administrativeApplicationThree from "./administrative/applicationThree.vue";
import administrativeUoloadApplication from "./administrative/uploadApplication.vue";
import { getApplyStorage, getStorageNurseApplyInfo,getInfo,getApplyStorageAdmin } from "@/utils/api";
export default {
  components: {
    AddType,
    ApplicationOne,
    ApplicationTwo,
    ApplicationThree,
    UoloadApplication,
    SubmitSuccess,
    nurseApplicationOne,
    nurseApplicationTwo,
    nurseApplicationThree,
    nurseUoloadApplication,
    administrativeApplicationOne,
    administrativeApplicationTwo,
    administrativeApplicationThree,
    administrativeUoloadApplication,
  },
  watch: {
    active(newVal, oldVal) {
      window.scrollTo(0, 0);
    },
  },
  data() {
    return {
      isNurse: 0,
      active: 1,
      progress: 1,
      form: {
        trainType: "0",
        applyBasic: {
          nativePlace: "",
        },
        applyAttList: [],
        applyDeptList: [],
        applyStudyList: [],
        applyWorkList: [],
      },
      administrativeForm: {
        trainType: "0",
        applyBasic: {
          nativePlace: "",
        },
        applyAttList: [],
        applyDeptList: [],
        applyStudyList: [],
        applyWorkList: [],
      },
      nurseForm: {
        trainType: "1",
        applyBasic: {
          nativePlace: "",
        },
        applyAttList: [],
        applyDeptList: [],
        applyStudyList: [],
        applyWorkList: [],
      },
      applyId: "",
      user: {}, //用户信息
    };
  },
  created() {
    this.user = JSON.parse(localStorage.getItem("userInfo"));
    if (this.user.data) {
      this.user = this.user.data;
    }
    if (this.$route.query.progress) {
      this.progress = Number(this.$route.query.progress);
    }
    if (this.$route.query.active) {
      this.active = Number(this.$route.query.active);
    }
    if (this.$route.query.applyId) {
      this.applyId = this.$route.query.applyId;
    }
    if (this.$route.query.trainType) {
      this.isNurse = Number(this.$route.query.trainType);;
    }
    this.getUserInfo()
  },
  mounted() {},
  methods: {
    getUserInfo() {
      getInfo().then((userInfo) => {
        this.user = userInfo.user
      });
    },
    async getStroge(e) {
      let res = null;
      if (e == 0) {
        res = await getApplyStorage();
        this.init(res, e);
      } else if (e == 1) {
        res = await getStorageNurseApplyInfo();
        this.init(res, e);
      }else if (e == 2) {
        res = await getApplyStorageAdmin();
        this.init(res, e);
      }
    },
    init(res, e) {
      if (res.data && res.data.applyStudyList) {
        res.data.applyStudyList.forEach((item) => {
          if (!item.studyEducation) item.studyEducation = "";
        });
      }
      for (const key in res.data) {
        if (Object.hasOwnProperty.call(res.data, key)) {
          const item = res.data[key];
          if (item == null || item == undefined) {
            delete res.data[key];
          }
        }
      }
      if (res.data && !res.data.applyBasic.nativePlace) {
        res.data.applyBasic.nativePlace = "";
      }
     if (e == 0) {
        Object.assign(this.form, res.data || {});
      } else if(e == 1) {
        Object.assign(this.nurseForm, res.data || {});
      }else if(e == 2) {
        Object.assign(this.administrativeForm, res.data || {})
        // this.administrativeForm.trainType = "2";
        this.$set(this.administrativeForm, "trainType", "2");
        console.log(this.administrativeForm, "行政表单数据");
      }
      this.active = 2;
      this.progress = 2;
    },
  },
};
</script>
<style lang="scss" scoped>
// .applyType {
//   margin-top: 110px;
// }
// .remark {
//   margin: 32px 0 110px 0;
// }
// .el-button--primary {
//   padding: 0;
// }
.backIndex:hover {
  cursor: pointer;
}
// .formTitle {
//   margin: 50px 0px 30px 240px;
// }
// ::v-deep.form {
//   margin-bottom: 47px;
//   overflow: hidden;
//   .el-form-item__label {
//     color: #333;
//     font-size: 22px;
//     padding: 0;
//   }
//   .jiben .left {
//     // margin-right: 38px;
//     width: 206px;
//     & > div:nth-child(1) {
//       & > img {
//         width: 100%;
//         height: 252px;
//       }
//     }
//   }
//   .study {
//     padding: 0 0 0 240px;
//     margin-bottom: 40px;
//   }
//   .footer {
//     .a {
//       display: inline-block;
//       width: 40px;
//       line-height: 36px;
//       text-align: center;
//       border-radius: 5px;
//       height: 40px;
//       color: #333;
//       border: #999999 solid 2px;
//       margin-left: 30px;
//       &:hover {
//         border-color: #2d53c8;
//       }
//     }
//     & > .a:last-child {
//       width: 110px;
//     }
//     & > .active {
//       border-color: #2d53c8;
//     }
//   }
// }
</style>
